import { useState } from "react";

import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from '@mui/icons-material/Search';
import { DateTimeInput } from "../formComponents/DateTimeInput";
import { TimeDevice } from "../formComponents/TimeDevice";

export function AddForm({
  isOpen,
  onClose,
  employeePersonalInformationId,
  setEmployeePersonalInformationId,
  employeePersonalInformationFullName,
  setEmployeePersonalInformationFullName,
  timeIn,
  setTimeIn,
  deviceNameTimeIn,
  setDeviceNameTimeIn,
  timeOut,
  setTimeOut,
  deviceNameTimeOut,
  setDeviceNameTimeOut,
  setShowEmployeeForm,
  handleSubmit }) {
  const [errorState, setErrorState] = useState(false);

  const submit = (e) => {
    if (!employeePersonalInformationId
      || !timeIn
      // || !deviceNameTimeIn
      || !timeOut
      // || !deviceNameTimeOut
    ) {
      setErrorState(true);
      return;
    }
    handleSubmit(e);
    setErrorState(false);
    handleClose();
  };

  const handleClose = () => {
    onClose();
    setEmployeePersonalInformationId("");
    setEmployeePersonalInformationFullName("");
    setTimeIn("");
    setDeviceNameTimeIn("");
    setTimeOut("");
    setDeviceNameTimeOut("");
    setErrorState(false);
  };

  return (
    <>
      <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Add Time Entry</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body">
              <div className="popUp-item info-item column">
                <div className="info-item-label">Employee</div>
                <div className="info-item-input">
                  <div className="info-item-holder employee-select row" style={{ flexDirection: "row", justifyContent: "normal" }}>
                    <input
                      readOnly
                      className='employeeInput-select'
                      placeholder="Employee"
                      value={employeePersonalInformationId ? (employeePersonalInformationFullName) : employeePersonalInformationId}
                    />
                    <button className="select row"
                      onClick={() => setShowEmployeeForm(true)}
                    ><SearchIcon /></button>
                  </div>
                  <span style={{
                    visibility: !employeePersonalInformationId && errorState ? "visible" : "hidden",
                    color: "#ff6565",
                    fontSize: "12px"
                  }}>Please fill up this field
                  </span>
                </div>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Time In</div>
                <div className="info-item-input">
                  <DateTimeInput date={timeIn} setDate={setTimeIn} />
                </div>
                <span style={{
                  visibility: !timeIn && errorState ? "visible" : "hidden",
                  color: "#ff6565",
                  fontSize: "12px"
                }}>Please fill up this field
                </span>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Time In Device</div>
                <div className="info-item-input">
                  <TimeDevice device={deviceNameTimeIn} setDevice={setDeviceNameTimeIn} />
                </div>
                <span style={{
                  visibility: "hidden",
                  color: "#ff6565",
                  fontSize: "12px"
                }}>Please fill up this field
                </span>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Time Out</div>
                <div className="info-item-input">
                  <DateTimeInput date={timeOut} setDate={setTimeOut} />
                </div>
                <span style={{
                  visibility: !timeOut && errorState ? "visible" : "hidden",
                  color: "#ff6565",
                  fontSize: "12px"
                }}>Please fill up this field
                </span>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Time Out Device</div>
                <div className="info-item-input">
                  <TimeDevice device={deviceNameTimeOut} setDevice={setDeviceNameTimeOut} />
                </div>
                <span style={{
                  visibility: "hidden",
                  color: "#ff6565",
                  fontSize: "12px"
                }}>Please fill up this field
                </span>
              </div>
            </div>
            <div className="buttons row" style={{ justifyContent: "end", padding: "20px 40px" }}>
              <button id="add-family"
                className="save row"
                onClick={(e) => submit(e)}>
                SAVE
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}